import React, { useEffect } from 'react';
import { initMetaPixel, trackPageView } from './lib/metaPixel';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { SolutionSection } from './components/SolutionSection';
import { ContentSection } from './components/ContentSection';
import { DifferenceSection } from './components/DifferenceSection';
import { AudienceSection } from './components/AudienceSection';
import { AuthorStory } from './components/AuthorStory';
import { BenefitsSection } from './components/BenefitsSection';
import { PricingCTA } from './components/PricingCTA';
import { FAQSection } from './components/FAQSection';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    initMetaPixel();
    trackPageView();
  }, []);
  return <div className="min-h-screen bg-warm-bg font-sans text-warm-dark selection:bg-sage/30" data-id="element-0">
      <Header data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <SolutionSection data-id="element-4" />
      <ContentSection data-id="element-5" />
      <DifferenceSection data-id="element-6" />
      <AudienceSection data-id="element-7" />
      <AuthorStory data-id="element-8" />
      <BenefitsSection data-id="element-9" />
      <PricingCTA data-id="element-10" />
      <FAQSection data-id="element-11" />
      <Footer data-id="element-12" />
    </div>;
}